<div class="flex flex-col md:flex-row items-center justify-between mb-12">
  <app-dashboard-header></app-dashboard-header>

  <div class="flex gap-3 items-center bg-white p-3 rounded shadow mt-3 md:mt-0">
    @for(filter of chartFilters()[0]; track $index){
    <div class="flex flex-col gap-1 min-w-[120px]">
      <label class="text-md font-medium">{{ filter.label! | titlecase }}:</label>
      <p-select 
        [options]="filter.dropdownOptions" 
        [placeholder]="filter.dropdownOptions.length
          ? (filter.dropdownOptions[0].label | titlecase)
          : ''
        "
        [(ngModel)]="globalSelectedFilters()[filter.key]"
        (onChange)="onFilterSelect(filter.key, $event.value)" 
        [disabled]="filter.key === 'quarter' && (!globalSelectedFilters()['years'] || globalSelectedFilters()['years'] === 'All')"
        [class.locked-filter]="filter.key === 'quarter' && (!globalSelectedFilters()['years'] || globalSelectedFilters()['years'] === 'All')"
        [fluid]="true" 
        class="w-full"
        appendTo="body"
        [showClear]="globalSelectedFilters()[filter.key] !== 'All'">
      </p-select>
    </div>
    }
  </div>
</div>

<div class="flex flex-col gap-4">
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-3">
    @for (config of kpiCardsConfig(); track $index){
    <kpi-card [config]="config"></kpi-card>
    }
  </div>

  <co-panel [config]="kpiPanelConfig">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 my-3">
      @for (config of moreKpiCardsConfig(); track $index){
      <kpi-card [config]="config"></kpi-card>
      }
    </div>
  </co-panel>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-charts-widget1 cssClass="h-full" [chartCase]="'PROVIDER_UTILIZATION.CLAIM_RATE' | translate" chartType="line"
      height="200" [hoverLabels]="'PROVIDER_UTILIZATION.CLAIM_RATE' | translate" graphColors="#125773"
      [data]="claimRate()" [isXLabels]="true" [isYLabels]="true">
    </app-charts-widget1>

    <app-charts-widget1 cssClass="h-full" [chartCase]="'PROVIDER_UTILIZATION.INCIDENT_TYPE' | translate" chartType="bar"
      [isHorizontalBar]="true" height="300" [hoverLabels]="'PROVIDER_UTILIZATION.INCIDENT' | translate"
      [data]="incidentType()" [isYLabels]="true" format="%">
    </app-charts-widget1>
    <!--end::Incident type chart -->
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <app-tree-map-chart cssClass="h-full" [chartCase]="'PROVIDER_UTILIZATION.EXPENSES_CATEGORIES' | translate"
      chartType="treemap" height="300" [data]="expensesCategories()">
    </app-tree-map-chart>

    <!--end:Expenses Categories Chart -->

    <!--begin:Accomodation Chart -->

    <app-charts-widget1
      cssClass="h-full"
      [chartCase]="'PROVIDER_UTILIZATION.ACCOMMODATION_TYPE' | translate"
      chartType="bar"
      [isHorizontalBar]="true"
      height="300"
      hoverLabels="Claim"
      [data]="accommondationType()"
      [isYLabels]="true"
      format="%"
    >
    </app-charts-widget1>
  </div>
  <!--end:Accomodation Chart -->

  <!--begin:KENs Chart -->

  <div class="w-full">
    <top-ten-bar-chart [chartReady]="chartReadyKen()" cssClass="h-full" [chartCase]="'PROVIDER_UTILIZATION.TOP10_KEN'" chartType="bar"
      height="300" hoverLabels="Incident" graphColors="#125773" [data]="topTenDrg()" [isXLabels]="true"
      xAxisLabel="{{ 'PROVIDER_UTILIZATION_GRAPH.KEN_CODE' | translate }}" [isYLabels]="true"
      yAxisLabel="{{ 'PROVIDER_UTILIZATION_GRAPH.AMOUNT' | translate }}" (onChange)="onKenFilterChange($event)" chartTitle="PROVIDER_UTILIZATION.TOP10_KEN">
    </top-ten-bar-chart>
  </div>

  <div class="w-full">
    <co-bar-plot [chartReady]="chartReadyIcd()" cssClass="h-full flex flex-col"
      [chartHeader]="'PROVIDER_UTILIZATION.TOTAL_CLAIMS' | translate" [data]="mostCostlyICD10sChartData()"
      [hoverLabels]="mostCostlyICD10sChartHoverLabels()" [isHorizontalBar]="false" [isXLabels]="true"
      xAxisTitle="{{ 'PROVIDER_UTILIZATION_GRAPH.ICD10_CODE' | translate }}" [isYLabels]="true"
      yAxisTitle="{{ 'PROVIDER_UTILIZATION_GRAPH.AVG_COST' | translate }}" [isLegend]="true"
      [tooltipFormatter]="mostCostlyICD10sChartFormatTooltip()" [filterOptions]="chartFilters()[-1]"
      [selectedFilters]="mostCostlyICD10sSelectedFilters()" (onFilterChange)="onMostCostlyICD10sFilterChanged($event)"
      [ChartStats]="mostCostlyICD10sStats" testResult="Mann Whitney U">
    </co-bar-plot>
  </div>
  <div class="w-full">
    <co-bar-plot [chartReady]="chartReadyCostlyMdc()" cssClass="h-full flex flex-col"
      [chartHeader]="'PROVIDER_UTILIZATION.MOST_COSTLY_MDC' | translate" [data]="mostCostlyMdcsChartData()"
      [hoverLabels]="mostCostlyMdcsChartHoverLabels()" [isHorizontalBar]="false" [isXLabels]="true"
      xAxisTitle="{{ 'PROVIDER_UTILIZATION_GRAPH.MDC_CODE' | translate }}" [isYLabels]="true"
      yAxisTitle="{{ 'PROVIDER_UTILIZATION_GRAPH.TOTAL_COST' | translate }}" [isLegend]="true"
      [tooltipFormatter]="mostCostlyMdcsChartFormatTooltip()" [filterOptions]="chartFilters()[129]"
      [selectedFilters]="mostCostlyMdcsSelectedFilters()" (onFilterChange)="onMostCostlyMdcsFilterChanged($event)"
      [ChartStats]="mostCostlyMdcsStats" testResult="Mann Whitney U">
    </co-bar-plot>
  </div>
  <div class="w-full mb-3">
    <co-multiple-y-axis-chart [chartReady]="chartReadyFrequentMdc()" cssClass="h-full flex flex-col"
      [chartHeader]="'PROVIDER_UTILIZATION.MOST_FREQUENT_MDC' | translate" [chartData]="mostFrequentMdcSignal()"
      [chiSquaredResult]="mostFrequentMdcChiSquaredResult()" [filterOptions]="chartFilters()[128]"
      [selectedFilters]="mostFrequentMdcSelectedFilters()" (onFilterChange)="onMostFrequentMdcFiltersChange($event)"
      testResult="Chi Squared" [xAxisLabel]="'PROVIDER_UTILIZATION_GRAPH.MDC_CODE'"
      [cumulativeLabel]="'PROVIDER_UTILIZATION_GRAPH.CUMULATIVE_PERCENT'" [tooltipBuilder]="mdcTooltip">
    </co-multiple-y-axis-chart>
  </div>
  <!--end:DRGs Chart -->
</div>
<!-- } -->